import ccsj from 'countrycitystatejson'

export const CONTINENTS = [
  { code: 'AS', name: '亚洲', enName: 'Asia' },
  { code: 'EU', name: '欧洲', enName: 'Europe' },
  { code: 'NA', name: '北美洲', enName: 'North America' },
  { code: 'SA', name: '南美洲', enName: 'South America' },
  { code: 'AF', name: '非洲', enName: 'Africa' },
  { code: 'OC', name: '大洋洲', enName: 'Oceania' }
]

export const COUNTRY_CONTINENT_MAP = {
  AF: 'AS', AX: 'EU', AL: 'EU', DZ: 'AF', AS: 'OC', AD: 'EU', AO: 'AF', AI: 'NA',
  AG: 'NA', AR: 'SA', AM: 'AS', AW: 'NA', AU: 'OC', AT: 'EU', AZ: 'AS', BS: 'NA',
  BH: 'AS', BD: 'AS', BB: 'NA', BY: 'EU', BE: 'EU', BZ: 'NA', BJ: 'AF', BM: 'NA',
  BT: 'AS', BO: 'SA', BQ: 'NA', BA: 'EU', BW: 'AF', BV: 'AN', BR: 'SA', IO: 'AS',
  VG: 'NA', BN: 'AS', BG: 'EU', BF: 'AF', BI: 'AF', CV: 'AF', KH: 'AS', CM: 'AF',
  CA: 'NA', KY: 'NA', CF: 'AF', TD: 'AF', CL: 'SA', CN: 'AS', CX: 'AS', CC: 'AS',
  CO: 'SA', KM: 'AF', CG: 'AF', CD: 'AF', CK: 'OC', CR: 'NA', CI: 'AF', HR: 'EU',
  CU: 'NA', CW: 'NA', CY: 'EU', CZ: 'EU', DK: 'EU', DJ: 'AF', DM: 'NA', DO: 'NA',
  EC: 'SA', EG: 'AF', SV: 'NA', GQ: 'AF', ER: 'AF', EE: 'EU', SZ: 'AF', ET: 'AF',
  FK: 'SA', FO: 'EU', FJ: 'OC', FI: 'EU', FR: 'EU', GF: 'SA', PF: 'OC', TF: 'AN',
  GA: 'AF', GM: 'AF', GE: 'AS', DE: 'EU', GH: 'AF', GI: 'EU', GR: 'EU', GL: 'NA',
  GD: 'NA', GP: 'NA', GU: 'OC', GT: 'NA', GG: 'EU', GN: 'AF', GW: 'AF', GY: 'SA',
  HT: 'NA', HM: 'AN', VA: 'EU', HN: 'NA', HK: 'AS', HU: 'EU', IS: 'EU', IN: 'AS',
  ID: 'AS', IR: 'AS', IQ: 'AS', IE: 'EU', IM: 'EU', IL: 'AS', IT: 'EU', JM: 'NA',
  JP: 'AS', JE: 'EU', JO: 'AS', KZ: 'AS', KE: 'AF', KI: 'OC', KP: 'AS', KR: 'AS',
  KW: 'AS', KG: 'AS', LA: 'AS', LV: 'EU', LB: 'AS', LS: 'AF', LR: 'AF', LY: 'AF',
  LI: 'EU', LT: 'EU', LU: 'EU', MO: 'AS', MG: 'AF', MW: 'AF', MY: 'AS', MV: 'AS',
  ML: 'AF', MT: 'EU', MH: 'OC', MQ: 'NA', MR: 'AF', MU: 'AF', YT: 'AF', MX: 'NA',
  FM: 'OC', MD: 'EU', MC: 'EU', MN: 'AS', ME: 'EU', MS: 'NA', MA: 'AF', MZ: 'AF',
  MM: 'AS', NA: 'AF', NR: 'OC', NP: 'AS', NL: 'EU', NC: 'OC', NZ: 'OC', NI: 'NA',
  NE: 'AF', NG: 'AF', NU: 'OC', NF: 'OC', MK: 'EU', MP: 'OC', NO: 'EU', OM: 'AS',
  PK: 'AS', PW: 'OC', PS: 'AS', PA: 'NA', PG: 'OC', PY: 'SA', PE: 'SA', PH: 'AS',
  PN: 'OC', PL: 'EU', PT: 'EU', PR: 'NA', QA: 'AS', RE: 'AF', RO: 'EU', RU: 'EU',
  RW: 'AF', BL: 'NA', SH: 'AF', KN: 'NA', LC: 'NA', MF: 'NA', PM: 'NA', VC: 'NA',
  WS: 'OC', SM: 'EU', ST: 'AF', SA: 'AS', SN: 'AF', RS: 'EU', SC: 'AF', SL: 'AF',
  SG: 'AS', SX: 'NA', SK: 'EU', SI: 'EU', SB: 'OC', SO: 'AF', ZA: 'AF', GS: 'AN',
  SS: 'AF', ES: 'EU', LK: 'AS', SD: 'AF', SR: 'SA', SJ: 'EU', SE: 'EU', CH: 'EU',
  SY: 'AS', TW: 'AS', TJ: 'AS', TZ: 'AF', TH: 'AS', TL: 'AS', TG: 'AF', TK: 'OC',
  TO: 'OC', TT: 'NA', TN: 'AF', TR: 'EU', TM: 'AS', TC: 'NA', TV: 'OC', UG: 'AF',
  UA: 'EU', AE: 'AS', GB: 'EU', US: 'NA', UM: 'OC', VI: 'NA', UY: 'SA', UZ: 'AS',
  VU: 'OC', VE: 'SA', VN: 'AS', WF: 'OC', EH: 'AF', YE: 'AS', ZM: 'AF', ZW: 'AF'
}

export function buildCountryTree(countries) {
  const continentMap = {}
  CONTINENTS.forEach(continent => {
    continentMap[continent.code] = {
      value: 'continent_' + continent.code,
      label: continent.name,
      children: []
    }
  })
  countries.forEach(country => {
    const continentCode = COUNTRY_CONTINENT_MAP[country.shortName]
    if (continentCode && continentMap[continentCode]) {
      continentMap[continentCode].children.push({
        value: country.shortName,
        label: country.name
      })
    }
  })
  return CONTINENTS
    .map(c => continentMap[c.code])
    .filter(node => node.children.length > 0)
    .map(node => {
      node.children.sort((a, b) => a.label.localeCompare(b.label, 'zh-CN'))
      return node
    })
}

export function isCountryInEurope(countryCode) {
  return COUNTRY_CONTINENT_MAP[countryCode] === 'EU'
}

const mapCountryFromSelect = (arr) => {
  return (arr || []).map(item => {
    const shortName = String(item.value || '').trim()
    const name = String(item.label || '').trim()
    if (!shortName || !name) return null
    const continentShort = COUNTRY_CONTINENT_MAP[shortName]
    return {
      shortName,
      name,
      enName: name,
      continent: continentShort || ''
    }
  }).filter(Boolean)
}

export async function fetchCountryList($fetch, onLog) {
  let source = 'local ccsj'
  let countries = []
  let remoteList = []
  try {
    const res = await $fetch.post('/base/select')({ type: 'CountryEnum' }).catch(() => null)
    remoteList = (res && Array.isArray(res.data) && res.data.length) ? res.data : []
  } catch (e) {
    if (typeof onLog === 'function') onLog('warn', '/base/select CountryEnum failed, fallback to local ccsj.getCountries()', e)
  }
  if (remoteList.length) {
    source = '/base/select CountryEnum'
    countries = mapCountryFromSelect(remoteList)
  } else {
    countries = ccsj.getCountries() || []
  }
  const countryTree = buildCountryTree(countries) || []
  const leafCount = (countryTree || []).reduce((s, n) => s + (Array.isArray(n.children) ? n.children.length : 0), 0)
  if (typeof onLog === 'function') {
    onLog('info', 'countries loaded (source: ' + source + '):', {
      countries: (countries || []).length,
      leafCount,
      hasCountryTree: leafCount > 0,
      countryTreeSample: (countryTree || []).slice(0, 2),
      firstCountrySample: (countries && countries[0]) || null
    })
  }
  return {
    source,
    countries,
    countryTree,
    leafCount,
    hasCountryTree: leafCount > 0
  }
}
